var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as API from './api';
import * as UserSrv from './user-service';
class ChallengeTable {
    constructor(offset, length = 100, load = false) {
        this.offset = offset;
        this.length = length;
        this.load = load;
    }
}
let Status = class Status extends Vue {
    constructor() {
        super(...arguments);
        this.identity = UserSrv.identity;
        this.is_admin = UserSrv.is_admin();
        this.filter = new API.ChallengeFilter();
        this.query_filter = new API.ChallengeFilter();
        this.total_count = 0;
        this.tables = null;
        this.pending_scroll = null;
        this.page = 0;
        this.table_size = 0;
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            let query = this.$route.query['filter'];
            if (query !== undefined) {
                this.filter.load(query);
                this.query_filter.load(query);
            }
            let offset = this.page * 15;
            let partial_list = yield API.listChallengeTemp(offset, this.query_filter, null);
            if (partial_list !== 'Error') {
                this.total_count = partial_list.total_count;
                this.table_size = partial_list.data.length;
                let tables = [];
                let off = 0;
                if (this.table_size > 0) {
                    tables.push(new ChallengeTable(0, this.table_size));
                }
                // for (; off < this.table_size; off += 100) {
                //   tables.push(new ChallengeTable(off))
                // }
                tables.reverse();
                this.tables = tables;
                if (tables.length > 0) {
                    tables[0].load = true;
                    tables[0].challenges = partial_list.data.slice(0, tables[0].length).reverse();
                    this.$set(this.tables, 0, tables[0]);
                }
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
            //Use page button instead of scroll
            // window.addEventListener('scroll', this.onScroll) 
        });
    }
    //Use page button instead of scroll
    // destroyed() {
    //   window.removeEventListener('scroll', this.onScroll)
    // }
    onApplyFilter() {
        this.$router.push({ name: 'status', query: { filter: this.filter.serialize() } });
    }
    onClearFilter() {
        this.$router.push({ name: 'status', query: { filter: JSON.stringify({ user_uid: null, problem_uid: null, result: null, category: null }) } });
        // this.$router.push({ name: 'status' })
    }
    onMySubmissionFilter() {
        if (this.identity !== null) {
            this.$router.push({ name: 'status', query: { filter: JSON.stringify({ user_uid: this.identity.uid, problem_uid: null, result: null, category: null }) } });
        }
    }
    onPrevPage() {
        if (this.page > 0) {
            this.page -= 1;
            this.fetchData();
        }
    }
    onNextPage() {
        if ((this.page + 1) * 15 < this.total_count) {
            this.page += 1;
            this.fetchData();
        }
    }
    //Use page button instead of scroll
    // async onScroll() {
    //   if (this.pending_scroll !== null) {
    //     clearTimeout(this.pending_scroll);
    //   }
    //   this.pending_scroll = setTimeout(async () => {
    //     this.pending_scroll = null
    //     await this.update()
    //   }, 100)
    // }
    // async update() {
    //   console.log("update")
    //   if (this.tables !== null) {
    //     let scroll = window.scrollY
    //     let search_index = 0
    //     let search_lower = 0
    //     let search_upper = this.tables.length - 1
    //     while (search_lower <= search_upper) {
    //       let mid = Math.floor((search_lower + search_upper) / 2)
    //       let e_table = (this.$refs[`table_${mid}`] as HTMLDivElement[])[0]
    //       let top = e_table.getBoundingClientRect().top
    //       if (top >= 0) {
    //         search_index = mid
    //         search_upper = mid - 1
    //       } else {
    //         search_lower = mid + 1
    //       }
    //     }
    //     let loading_promise = []
    //     for (let idx = Math.max(0, search_index - 1); idx < Math.min(this.tables.length, search_index + 1); idx++) {
    //       let table = this.tables[idx]
    //       if (!table.load) {
    //         table.load = true
    //         API.listChallenge(table.offset, this.query_filter).then((partial_list: 'Error' | API.PartialList<API.Challenge | null>) => {
    //           if (partial_list !== 'Error') {
    //             table.challenges = partial_list.data.slice(0, table.length).reverse()
    //             if (this.tables !== null) {
    //               this.$set(this.tables, idx, table)
    //             }
    //           }
    //         })
    //       }
    //     }
    //   }
    // }
    getResult(state, result) {
        return API.getResult(state, result);
    }
    onRejudge(challenge_uid) {
        API.rejudgeSingleChallenge(challenge_uid).then((ret) => {
            // console.log(ret)
            this.$router.go(0);
        });
    }
};
__decorate([
    Watch('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Status.prototype, "fetchData", null);
Status = __decorate([
    Component
], Status);
export default Status;



// WEBPACK FOOTER //
// ./src/Status.vue